import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Ticket } from 'src/app/models/ticket/ticket.model';

@Component({
  selector: 'app-ticket-detail-contact',
  templateUrl: './ticket-detail-contact.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TicketDetailContactComponent {
  @Input() ticket: Ticket;
}
